<form [formGroup]="form">
  <mojo-autocomplete
    (inputChange)="loadAutocompleteHiringManagersAndRecruiters($event)"
    [options]="reportPipelineService.filteredOptions$ | async"
    [multi]="false"
    appearance="fill"
    bindLabel="label"
    [useChips]="false"
    color="accent"
    formControlName="selectedPerson"
    label="Search by recruiter and hiring manager"
  >
  </mojo-autocomplete>
</form>
